import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        inseeAndKbisStepAvailable: Boolean,
    }


    static targets = [
        'documentTypeInput',
        'documentUploadForm',
        'validationIdCardStep',
        'validationDriverLicenseCardStep',
        'validationResidentPermitStep',
        'validationStep',
        'idCardFront',
        'idCardBack',
        'driverLicenseCardFront',
        'driverLicenseCardBack',
        'residentPermitFront',
        'residentPermitBack',
        'validationInseeStep',
        'validationKbisStep',
    ];

    initialize() {
        $(this.element).on('hide.bs.modal', () => {
            if (this.inseeAndKbisStepAvailableValue) {
                this.verifyInseeStepHide();
                this.verifyKbisStepHide();
            } else {
                this.verifyIdCardStepHide()
                this.verifyDriverLicenseCardStepHide();
                this.verifyResidentPermitStepHide();
            }
        });
    }

    idCardFrontOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    idCardBackOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    driverLicenseCardFrontOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    driverLicenseCardBackOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    residentPermitFrontOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    residentPermitBackOnChange(event) {
        const label = event.target.labels[0];

        label.classList.remove('btn-primary-dark')
        label.classList.add('btn-outline-primary-dark')

        if (!label.children[0]) {
            label.innerHTML += "<i class='mdi mdi-check-circle text-success font-16 ps-1'></i>"
        }
    }

    documentTypeChange(event) {
        const modal = this.element;
        const input = event.target;
        const value = input.value;
        const option = input.querySelector(`option[value="${value}"]`);
        const container = modal.querySelector(option.dataset.target);

        this.documentUploadFormTargets.forEach(uploadForm => {
            uploadForm.style.setProperty('display', 'none');
        });

        container.style.removeProperty('display');
    }

    documentChange(event) {
        showPreloader();

        const input = event.target;
        const files = event.target.files;
        const formData = new FormData();

        formData.append('file', files[0]);
        formData.append('document_type', input.dataset.documentType);
        $.ajax({
            url: routes['app_accountsettings_uploadeasytransackycdocument'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: result => {
                if (result.status) {
                    addAlert('success', result.message || 'Success message!');
                } else {
                    addAlert('danger', result.message || 'Error message!');
                    hidePreloader();
                    input.value = null;

                    return;
                }

                $(this.element).modal('hide');
                input.value = null;
                window.location.reload();
            },
            error: () => {
                addAlert('danger', 'Error message!');
                hidePreloader();
                input.value = null;
            },
        });
    }

    documentChangeIdCard(event) {
        showPreloader();

        if (
            this.idCardFrontTarget.files.length === 0
            || this.idCardBackTarget.files.length === 0
        ) {
            hidePreloader();
            return;
        }

        const input = event.target;
        const formData = new FormData();

        formData.append('fileFront', this.idCardFrontTarget.files[0]);
        formData.append('fileBack', this.idCardBackTarget.files[0]);
        formData.append('document_type_file_front', this.idCardFrontTarget.dataset.documentType);
        formData.append('document_type_file_back', this.idCardBackTarget.dataset.documentType);

        $.ajax({
            url: routes['app_accountsettings_uploadeasytransackycdocument'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: result => {
                if (result.status) {
                    addAlert('success', result.message || 'Success message!');
                } else {
                    addAlert('danger', result.message || 'Error message!');
                    hidePreloader();
                    input.value = null;

                    return;
                }

                $(this.element).modal('hide');
                input.value = null;
                window.location.reload();
            },
            error: () => {
                addAlert('danger', 'Error message!');
                hidePreloader();
                input.value = null;
            },
        });
    }

    documentChangeDriverLicenseCard(event) {
        showPreloader();

        if (
            this.driverLicenseCardFrontTarget.files.length === 0
            || this.driverLicenseCardBackTarget.files.length === 0
        ) {
            hidePreloader();
            return;
        }

        const input = event.target;
        const formData = new FormData();

        formData.append('fileFront', this.driverLicenseCardFrontTarget.files[0]);
        formData.append('fileBack', this.driverLicenseCardBackTarget.files[0]);
        formData.append('document_type_file_front', this.driverLicenseCardFrontTarget.dataset.documentType);
        formData.append('document_type_file_back', this.driverLicenseCardBackTarget.dataset.documentType);

        $.ajax({
            url: routes['app_accountsettings_uploadeasytransackycdocument'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: result => {
                if (result.status) {
                    addAlert('success', result.message || 'Success message!');
                } else {
                    addAlert('danger', result.message || 'Error message!');
                    hidePreloader();
                    input.value = null;

                    return;
                }

                $(this.element).modal('hide');
                input.value = null;
                window.location.reload();
            },
            error: () => {
                addAlert('danger', 'Error message!');
                hidePreloader();
                input.value = null;
            },
        });
    }

    documentChangeResidentPermit(event) {
        showPreloader();

        if (
            this.residentPermitFrontTarget.files.length === 0
            || this.residentPermitBackTarget.files.length === 0
        ) {
            hidePreloader();
            return;
        }

        const input = event.target;
        const formData = new FormData();

        formData.append('fileFront', this.residentPermitFrontTarget.files[0]);
        formData.append('fileBack', this.residentPermitBackTarget.files[0]);
        formData.append('document_type_file_front', this.residentPermitFrontTarget.dataset.documentType);
        formData.append('document_type_file_back', this.residentPermitBackTarget.dataset.documentType);

        $.ajax({
            url: routes['app_accountsettings_uploadeasytransackycdocument'],
            type: 'post',
            data: formData,
            contentType: false,
            processData: false,
            success: result => {
                if (result.status) {
                    addAlert('success', result.message || 'Success message!');
                } else {
                    addAlert('danger', result.message || 'Error message!');
                    hidePreloader();
                    input.value = null;

                    return;
                }

                $(this.element).modal('hide');
                input.value = null;
                window.location.reload();
            },
            error: () => {
                addAlert('danger', 'Error message!');
                hidePreloader();
                input.value = null;
            },
        });
    }

    verifyIdCardStepShow() {
        this.validationIdCardStepTarget.style.removeProperty('display');
        this.validationStepTarget.style.setProperty('display', 'none');
    }

    verifyIdCardStepHide() {
        this.validationStepTarget.style.removeProperty('display');
        this.validationIdCardStepTarget.style.setProperty('display', 'none');
    }

    verifyDriverLicenseCardStepShow() {
        this.validationDriverLicenseCardStepTarget.style.removeProperty('display');
        this.validationStepTarget.style.setProperty('display', 'none');
    }

    verifyDriverLicenseCardStepHide() {
        this.validationStepTarget.style.removeProperty('display');
        this.validationDriverLicenseCardStepTarget.style.setProperty('display', 'none');
    }

    verifyInseeStepShow() {
        this.validationInseeStepTarget.style.removeProperty('display');
        this.validationStepTarget.style.setProperty('display', 'none');
    }

    verifyInseeStepHide() {
        this.validationInseeStepTarget.style.setProperty('display', 'none');
        this.validationStepTarget.style.removeProperty('display');
    }

    verifyKbisStepShow() {
        this.validationKbisStepTarget.style.removeProperty('display');
        this.validationStepTarget.style.setProperty('display', 'none');
    }

    verifyKbisStepHide() {
        this.validationKbisStepTarget.style.setProperty('display', 'none');
        this.validationStepTarget.style.removeProperty('display');
    }

    verifyResidentPermitStepShow() {
        this.validationResidentPermitStepTarget.style.removeProperty('display');
        this.validationStepTarget.style.setProperty('display', 'none');
    }

    verifyResidentPermitStepHide() {
        this.validationStepTarget.style.removeProperty('display');
        this.validationResidentPermitStepTarget.style.setProperty('display', 'none');
    }
}
